document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("loginPopup");
  if (!popup) return;

  const openBtns = document.querySelectorAll(".open-login-popup");
  const closeBtn = popup.querySelector(".login-popup-close");
  const overlay = popup.querySelector(".login-popup-overlay");

  const loginForm = popup.querySelector("#loginForm");
  const registerForm = popup.querySelector("#registerForm");
  const forgotForm = popup.querySelector("#forgotForm");

  // Open popup
  openBtns.forEach(btn => {
    btn.addEventListener("click", e => {
      e.preventDefault();
      closeAccountDropdown(); // Close default Savor account dropdown
      popup.style.display = "block";
      document.body.classList.add("popup-open");
      showForm("login");
      setTimeout(() => popup.classList.add("active"), 10);
    });
  });

  // Close popup
  function closePopup() {
    popup.classList.remove("active");
    document.body.classList.remove("popup-open");
    setTimeout(() => (popup.style.display = "none"), 200);
  }

  if (closeBtn) closeBtn.addEventListener("click", closePopup);
  if (overlay) overlay.addEventListener("click", closePopup);

  // Switch forms
  popup.querySelectorAll(".show-register").forEach(el =>
    el.addEventListener("click", e => {
      e.preventDefault();
      showForm("register");
    })
  );

  popup.querySelectorAll(".show-login").forEach(el =>
    el.addEventListener("click", e => {
      e.preventDefault();
      showForm("login");
    })
  );

  popup.querySelectorAll(".show-forgot").forEach(el =>
    el.addEventListener("click", e => {
      e.preventDefault();
      showForm("forgot");
    })
  );

  function showForm(type) {
    if (!loginForm || !registerForm || !forgotForm) return;

    loginForm.style.display = "none";
    registerForm.style.display = "none";
    forgotForm.style.display = "none";

    if (type === "login") loginForm.style.display = "block";
    if (type === "register") registerForm.style.display = "block";
    if (type === "forgot") forgotForm.style.display = "block";
  }

  // Helper: close Savor’s built-in account dropdown if open
  function closeAccountDropdown() {
    const dropdown = document.querySelector(
      ".header__account-dropdown, .account-popup, .header-account"
    );
    if (dropdown) {
      dropdown.classList.remove("active", "open");
      dropdown.style.display = "none";
    }
  }

  // Optional: close popup with ESC key
  document.addEventListener("keydown", e => {
    if (e.key === "Escape" && popup.classList.contains("active")) {
      closePopup();
    }
  });
});
